export default class ModuleConfig {
  private readonly code: string
  private readonly version: string
  private readonly title: string
  private readonly offline: boolean

  constructor(code: string, title: string, version: string, offline: boolean) {
    this.code = code
    this.title = title
    this.version = version
    this.offline = offline
  }

  getCode(): string {
    return this.code
  }

  getVersion(): string {
    return this.version
  }

  getModuleId(): string {
    return this.code + '_' + this.version
  }

  getTitle(): string {
    return this.title
  }

  isOffline(): boolean {
    return this.offline
  }
}
